var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContrast = function SvgContrast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#499D71",
    d: "M12.25.25H1.75C.925.25.25.925.25 1.75v10.5c0 .825.675 1.5 1.5 1.5h10.5c.825 0 1.5-.675 1.5-1.5V1.75c0-.825-.675-1.5-1.5-1.5m-9.187 3h2.625c.307 0 .562.255.562.563a.567.567 0 0 1-.562.562H3.063a.567.567 0 0 1-.563-.562c0-.308.255-.563.563-.563m8.437 9H1.75l10.5-10.5v9.75c0 .412-.338.75-.75.75M8.875 10v.938c0 .307.255.562.563.562a.567.567 0 0 0 .562-.562V10h.938a.567.567 0 0 0 .562-.562.567.567 0 0 0-.562-.563H10v-.937a.567.567 0 0 0-.562-.563.567.567 0 0 0-.563.563v.937h-.937a.567.567 0 0 0-.563.563c0 .307.255.562.563.562z"
  })));
};
export default SvgContrast;